import { gql } from '@apollo/client';

export const GET_BATCH_TESTS_FOR_FFIEC009 = gql`
query getBatchTestsForFFIEC009($input: GetBatchTestsForFFIEC009Input ) {
  getBatchTestsForFFIEC009(input: $input){
    batchId
    batchRunStatus
    ruleId
    period
    targetItem
    schedule
    mdrmNumber
    editTest
    isActive
    batchStartTime
    totalBatchTestRecords
    testPass
    testFail
    testError
    testRunStatus
    totalRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    aggregateRule
  }
}`;

export const GET_FAILED_TEST_RESULTS_FOR_FFIEC009 = gql`
query getFailedTestResultsForFFIEC009($input: GetFailedTestResultsForFFIEC009Input) {
  getFailedTestResultsForFFIEC009(input: $input){
    criteria {
      batchId
      ruleId
      targetItem
      schedule
      mdrmNumber
      editTest
      editNumber
      effectiveEndDate
      isActive
      aggregateRule
    }
    testResults {
      rowId
      testRunStatus
      errorColumns
      errorData
      errorDescription
      errorMessage
      testDate
      testPass
      testFail
      testError
      aggregateMdrm
      countryCode
      countryName
      aggregation
      total
      aggregateErrorMessage
      geographicalArea
      scheduleType
    }
    pagination{
      totalCount
    }
  }
}`;

export const GET_AUDIT_LOGS_FOR_FFIEC009 = gql`
query getAuditLogsForFFIEC009($input: GetAuditLogsForFFIEC009Input ) {
  getAuditLogsForFFIEC009(input: $input){
    eventId
    auditLogId
    commentId
    commentText
    user{
      firstName
      lastName
      initials
    }
    event{
      eventName
    }
    comment{
      commentText
    }
    createdAt
  }
}`;

export const GET_USER_COMMENTS_FOR_FFIEC009 = gql`
query getUserCommentsForFFIEC009($input: GetUserCommentForFFIEC009Input ) {
  getUserCommentsForFFIEC009(input: $input){
    commentText
    userId
    commentId
    createdAt
    batchId
    ruleId
    user{
      firstName
      lastName
      initials
    }
    FFIEC009AuditLog{
      eventId
      commentId
      auditLogId
      createdAt
    }
  }
}`;

export const GET_FFIEC009_DOWNLOADED_RESULT = gql`
query getFFIEC009SummaryDetailsForDownload($input: TenantIdInput) {
  getFFIEC009SummaryDetailsForDownload(input: $input) {
    batchId
    batchRunStatus
    totalRecords
    ruleId
    period
    targetItem
    schedule
    mdrmNumber
    editTest
    editNumber
    effectiveEndDate
    isActive
    batchStartTime
    testPass
    testFail
    testError
    testRunStatus
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    totalBatchTestRecords
  }
}`;

export const GET_LATEST_BATCH_FOR_FFIEC009 = gql`
query getCurrentStatusOfLatestBatchForFFIEC009($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFFIEC009(input: $input) {
    batchRunStatus
    batchId
    batchStartTime
    batchEndTime
    totalRecords
    fileName
    totalTestCases
  }
}`;

export const GET_SUMMARY_QUARTER_FOR_FFIEC009 = gql`
query getSummaryQuartersForFFIEC009($input: TenantIdInput) {
  getSummaryQuartersForFFIEC009(input: $input)
}`;

export const GET_QUARTER_FILTERED_BATCH_TEST_FOR_FFIEC009 = gql`
query getFFIEC009BatchTestsByQuarter($input: GetBatchTestsByQuarterInput) {
  getFFIEC009BatchTestsByQuarter(input: $input){
    batchId
    batchRunStatus
    ruleId
    period
    targetItem
    schedule
    mdrmNumber
    editTest
    isActive
    aggregateRule
    batchStartTime
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
  }
}`;

export const GET_FAILED_TEST_DATA_FOR_FFIEC009 = gql`
query getFailedRuleResultDetailsForFFIEC009($input: GetFailedRuleDetailsForFFIEC009Input) {
  getFailedRuleResultDetailsForFFIEC009(input: $input) {
    ruleCondition
    ruleDescription
    operator
    values
    result
  }
}
`;
